<template>
	<div class="container-fluid">
		<sheet-settings :sheet="sheet" :anonymous-mode="true"
		                @addParticipants="openParticipantsModal"></sheet-settings>

		<modal title="participants_add_modal_title" ref="modalNewParticipant"
		       modal-class="modal-bookers"
		       @apply="saveNewParticipant"
		       :disabled="savingNewParticipants" :applyDisabled="newParticipantInvalid">
			<div class="form-group" :class="{'has-danger':duplicateParticipant}">
				<label v-i18n="'participants_add_name_label'" class="form-control-label"></label>
				<input class="form-control" v-model="newParticipantName"/>
				<div class="form-control-feedback" v-if="duplicateParticipant"
				     v-i18n="'participants_duplicateName'"></div>
			</div>
		</modal>
	</div>
</template>

<script>
	import SheetSettings from '../../ui/sheet-settings.vue';
	import Modal from '../../ui/widgets/modal.vue';
	import store from '../../core/store';
	import {Booker} from '../../core/entities';

	export default {
		components: {
			SheetSettings,
			Modal
		},

		data () {
			return {
				sheet: store.globals.sheet,
				newParticipantName: "",
				savingNewParticipants: false,
				bookersNames: new Set(store.globals.sheet.parent.bookers.map(booker => booker.name.toLowerCase()))
			}
		},

		computed: {
			duplicateParticipant() {
				return this.newParticipantName && this.bookersNames.has(this.newParticipantName.trim().toLocaleLowerCase());
			},
			newParticipantInvalid() {
				return !this.newParticipantName || this.duplicateParticipant;
			},
			anonymousMode() {
				return sheet.share_mode > 0 || sheet.parent().password;
			}
		},

		methods: {
			openParticipantsModal() {
				this.newParticipantName = "";
				this.$refs.modalNewParticipant.show();
			},
			saveNewParticipant() {
				this.savingNewParticipants = true;
				var afterSave = () => {
					this.savingNewParticipants = false;
				}
				let book = this.sheet.parent;
				book.addChildren([{kind: 'Booker', name: this.newParticipantName}])
					.then((event) => {
						var bookerId = event.created[0].id;
						this.sheet.addChildren([{kind: 'Sheeter', booker_id: bookerId}])
							.then(() => {
								this.$refs.modalNewParticipant.hide()
							})
							.then(afterSave, afterSave);
					}, afterSave);
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/apps/anonymous/settings.vue